import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function LatestUpdates() {
  const latest = comics.slice(3, 9);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              实时同步韩国原版更新进度，精彩不错过
            </p>
          </div>
          <Link
            to="/category/romance"
            className="hidden md:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group block cursor-pointer"
              data-product-shop=""
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <span className="text-white text-xs font-medium">
                    第{comic.latestChapter}话
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 text-center">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-1 text-center">
                {comic.updateTime} 更新
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}